import {
  LearningGrain,
  type LearningGrainInput
} from '@/core/domain/learning/grain/LearningGrain.ts'
import type { ILearningGrainRepository } from '@/core/domain/learning/grain/ILearningGrainRepository.ts'

export class CreateLearningGrainUseCase {
  private readonly learningGrainRepository: ILearningGrainRepository

  constructor(learningGrainRepository: ILearningGrainRepository) {
    this.learningGrainRepository = learningGrainRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    grain: LearningGrainInput
  ): Promise<LearningGrain> {
    return this.learningGrainRepository.createLearningGrain(courseId, moduleId, grain)
  }
}
